import { Box, Typography } from '@mui/material';
import { withClarityTheme } from '@verifime/styles';
import { type TEntityPillKind, ENTITY_PILL_LABEL_MAP, ENTITY_PILL_ICON_MAP } from './constants';

export type TEntityPillProps = {
  kind: TEntityPillKind;
};

/**
 * EntityPill renders a compact labelled pill identifying the entity type.
 *
 * Background colour: theme.palette.surface.brandSubtle
 *   - Light mode: Eggplant 050 (#EFEDFF)
 *   - Dark mode:  Eggplant 900 (#1D1D4B)
 *
 * Text/icon colour: theme.palette.text.permanentBlack (light) /
 * theme.palette.text.permanentWhite (dark).
 */
function EntityPill({ kind }: TEntityPillProps) {
  const label = ENTITY_PILL_LABEL_MAP[kind];
  const IconComponent = ENTITY_PILL_ICON_MAP[kind];

  return (
    <Box
      sx={(theme) => ({
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.semantic.spacing.xs,
        px: theme.semantic.spacing.xs,
        py: theme.semantic.spacing['3xs'],
        // 6.25rem matches the design spec for the pill border radius.
        // This is a once off value that does not warrant a token.
        borderRadius: '6.25rem',
        backgroundColor: theme.palette.surface.brandSubtle,
        color:
          theme.palette.mode === 'light'
            ? theme.palette.text.permanentBlack
            : theme.palette.text.permanentWhite,
      })}
    >
      <IconComponent
        // @ts-expect-error MUI icon sx prop not typed on ComponentType
        sx={(theme) => ({
          fontSize: theme.semantic.fontSize.l,
          color:
            theme.palette.mode === 'light'
              ? theme.palette.text.permanentBlack
              : theme.palette.text.permanentWhite,
        })}
      />
      <Typography variant="button">{label}</Typography>
    </Box>
  );
}

export default withClarityTheme(EntityPill);
